// React
import { createContext } from "react"

// Types
import type { DetailType as DetailDataType } from "../types"
import type { DetailType } from "../utils"

export const DataContext = createContext<{
  detailreject: DetailDataType[]
  onAddDetail: (value: DetailType) => void
}>({
  detailreject: [],
  onAddDetail(_) {}
})